import { useQuery } from 'react-query';
import { getContext } from '@fiverr-private/fiverr_context';
import { getOrganizationComplianceData } from '../api';
import { ComplianceState } from '../types';

export const ORGANIZATION_CONFIG_QUERY_KEY = 'ORGANIZATION_CONFIG_QUERY_KEY';

export const useOrganizationConfigData = (autofetch = true) => {
    const { organizationId } = getContext();

    const userOrganizationDataQuery = useQuery({
        queryKey: [ORGANIZATION_CONFIG_QUERY_KEY, organizationId],
        queryFn: async (): Promise<ComplianceState> => getOrganizationComplianceData(organizationId),
        enabled: autofetch && !!organizationId,
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        staleTime: Infinity,
    });

    return {
        data: userOrganizationDataQuery?.data,
        isLoading: userOrganizationDataQuery?.isLoading || userOrganizationDataQuery?.isFetching,
    };
};
